import type { AvatarPreset } from '@livechat/shared';

import { avatarPresetImage } from '../avatar-presets.js';

export function MemberAvatar({
	dataUrl,
	displayName,
	enabled,
	preset,
	size = 'medium',
	tooltip,
}: {
	dataUrl?: string;
	displayName: string;
	enabled: boolean;
	preset: AvatarPreset;
	size?: 'small' | 'medium' | 'large';
	tooltip?: false | string;
}) {
	if (!enabled) return null;
	return (
		<span
			className={`member-avatar member-avatar-${size}`}
			title={tooltip === false ? undefined : (tooltip ?? displayName)}
		>
			<img alt="" src={dataUrl ?? avatarPresetImage(preset)} />
		</span>
	);
}
